import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from 'react';
import { dataProps } from '@uswitch/ev-utils/lib/contentful';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var __displayModMarker;

export var displayModMarker = function displayModMarker() {
  if (typeof window === 'undefined') return false;
  if (typeof __displayModMarker === 'undefined') __displayModMarker = window.localStorage.getItem('evcore/mod-marker');
  return __displayModMarker;
};
export default (function (_ref) {
  var entity = _ref.entity;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      init = _useState2[0],
      setInit = _useState2[1];

  useEffect(function () {
    return setInit(typeof window !== 'undefined');
  }, []);
  return init ? _jsx("script", _objectSpread({
    type: "application/mod-marker"
  }, dataProps(entity))) : null;
});